<template>
    <div class="layer messageBoxLayer alignCenter" style="z-index: 6" v-show="visible">
        <div class="mask fullSpace"></div>
        <div class="messageBox white_bg" :class="{show : visible}"
             :style="'margin-left: ' + marginLeft + 'px; margin-top: ' + marginTop + 'px;'">
            <header class="header primaryTextColor bold">{{title}}</header>
            <div class="body alignCenter font14r primaryTextColor">{{content}}</div>
            <footer class="footer paddingV16 bold" @click="visible = false">确定</footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "messageBox",
    data () {
        return {
            visible : false,
            title : '',
            content : '',
            marginLeft : 0,
            marginTop : 0,
        }
    },
    methods : {
        setData : function (data) {
            for (let key in data)
            {
                this[key] = data[key];
            }
        },
        show : function () {
            this.visible = true;
            // show and update margin after update.
        }
    },
    updated () {

        // calculate margin
        let messageBox = null;
        let list = this.$el.getElementsByClassName('messageBox');
        if (list.length)
        {
            messageBox = list[0];
        }
        if (!messageBox)
        {
            return;
        }
        let width   = messageBox.offsetWidth;
        let height  = messageBox.offsetHeight;

        this.marginLeft = 0 - width / 2;
        this.marginTop  = 0 - height / 2;
    }
}
</script>

<style lang="scss" scoped>
.messageBox {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 21;
    opacity: 0;

    min-width: 250px;
    border-radius:8px;

    transition: opacity .2s ease-in-out 0.2s;
    -webkit-transition: opacity .2s ease-out;
    -o-transition: opacity .2s ease-in-out 0.2s;
    -moz-transition: opacity .2s ease-in-out 0.2s;

    &.show {
        opacity : 1;
    }

    .header {
        padding: 16px 16px 12px;
    }
    .body {
        padding: 0 0 20px;
        border-bottom: solid 1px #F5F5F5;
    }
}
</style>
